import React, {useState} from 'react';
import {MenuItem, Tooltip} from "@mui/material";
import {StyledMenu} from "../../Sidebar.styled";
import {useTranslation} from "react-i18next";
import {useAuth} from "../../../../../contexts/AuthContext";
import {useLocation, useNavigate} from "react-router-dom";
import {ReactComponent as MoreSvg} from "../../../../../assets/icons/more.svg";
import {
    SidebarProfileAvatarFallback,
    SidebarProfileAvatarImg,
    SidebarProfileContainer,
    SidebarProfileMoreBtn
} from "./SidebarProfile.styled";
import {CurrentUser} from "../../../../../models/users.models";

interface SidebarProfileProps {
    user: CurrentUser | null;
    isOpen: boolean;
}

const SidebarProfile = ({ user, isOpen }: SidebarProfileProps) => {
    const { t } = useTranslation();
    const { logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [profileMenuAnchor, setProfileMenuAnchor] = useState<null | HTMLElement>(null);

    const isProfileActive = location.pathname === '/account-settings';

    const handleLogoutClick = () => {
        setProfileMenuAnchor(null);
        logout();
    };

    const initials = user?.firstName && user?.lastName
        ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
        : user?.firstName
            ? user.firstName.charAt(0)
            : user?.email
                ? user.email.charAt(0).toUpperCase()
                : '?';

    return (
        <>
            <SidebarProfileContainer>
                {isOpen && (user?.avatarBase64 ? (
                    <SidebarProfileAvatarImg src={user.avatarBase64} alt="Profile" />
                ) : (
                    <SidebarProfileAvatarFallback>
                        {initials}
                    </SidebarProfileAvatarFallback>
                ))}

                <Tooltip title={t('sidebar.moreProfileOptions')}>
                    <SidebarProfileMoreBtn onClick={(e) => setProfileMenuAnchor(e.currentTarget)}>
                        <MoreSvg />
                    </SidebarProfileMoreBtn>
                </Tooltip>

            </SidebarProfileContainer>

            <StyledMenu
                anchorEl={profileMenuAnchor}
                open={Boolean(profileMenuAnchor)}
                onClose={() => setProfileMenuAnchor(null)}
            >
                <MenuItem
                    onClick={() => {
                        setProfileMenuAnchor(null);
                        navigate('/account-settings');
                    }}
                    disabled={isProfileActive}
                >
                    {t('sidebar.accountSettings')}
                </MenuItem>

                <MenuItem onClick={handleLogoutClick}>
                    {t('sidebar.logout')}
                </MenuItem>
            </StyledMenu>
        </>
    );
};

export default SidebarProfile;